import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderTomorrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalenderTomorrow"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM19.5 8H4.5V19.5H19.5V8ZM11 10.4393L14.3107 13.75L11 17.0607L9.93934 16L12.1893 13.75L9.93934 11.5L11 10.4393Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalenderTomorrow;
